function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#201602, stroke:#000000}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "layer_1-2",
  "data-name": "layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M10 34c-2.76 0-5-2.69-5-6a4.68 4.68 0 0 1 5-5 4.68 4.68 0 0 1 5 5c0 3.31-2.24 6-5 6zm0-9a2.72 2.72 0 0 0-3 3c0 2.21 1.35 4 3 4s3-1.79 3-4a2.72 2.72 0 0 0-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2 48H0V37.58a5 5 0 0 1 4.45-5L9.89 32l.22 2-5.44.61a3 3 0 0 0-2.67 3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4 38h2v10H4zM14 38h2v10h-2zM24 34c-2.76 0-5-2.69-5-6a4.68 4.68 0 0 1 5-5 4.68 4.68 0 0 1 5 5c0 3.31-2.24 6-5 6zm0-9a2.72 2.72 0 0 0-3 3c0 2.21 1.35 4 3 4s3-1.79 3-4a2.72 2.72 0 0 0-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16 48h-2V37.58a5 5 0 0 1 4.45-5l5.44-.6.22 2-5.44.61a3 3 0 0 0-2.67 3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18 38h2v10h-2zM34 48h-2V37.58a3 3 0 0 0-2.67-3L23.89 34l.22-2 5.44.6a5 5 0 0 1 4.45 5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28 38h2v10h-2zM38 34c-2.76 0-5-2.69-5-6a4.68 4.68 0 0 1 5-5 4.68 4.68 0 0 1 5 5c0 3.31-2.24 6-5 6zm0-9a2.72 2.72 0 0 0-3 3c0 2.21 1.35 4 3 4s3-1.79 3-4a2.72 2.72 0 0 0-3-3zM32 38h2v10h-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48 48h-2V37.58a3 3 0 0 0-2.67-3L37.89 34l.22-2 5.44.6a5 5 0 0 1 4.45 5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M42 38h2v10h-2zM17 11c-2.76 0-5-2.69-5-6a4.68 4.68 0 0 1 5-5 4.68 4.68 0 0 1 5 5c0 3.31-2.24 6-5 6zm0-9a2.72 2.72 0 0 0-3 3c0 2.21 1.35 4 3 4s3-1.79 3-4a2.72 2.72 0 0 0-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9 22H7v-7.42a5 5 0 0 1 4.45-5L16.89 9l.22 2-5.44.61a3 3 0 0 0-2.67 3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11 15h2v7h-2zM27 22h-2v-7.42a3 3 0 0 0-2.67-3L16.89 11l.22-2 5.44.6a5 5 0 0 1 4.45 5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21 15h2v7h-2zM31 11c-2.76 0-5-2.69-5-6a4.68 4.68 0 0 1 5-5 4.68 4.68 0 0 1 5 5c0 3.31-2.24 6-5 6zm0-9a2.72 2.72 0 0 0-3 3c0 2.21 1.35 4 3 4s3-1.79 3-4a2.72 2.72 0 0 0-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41 22h-2v-7.42a3 3 0 0 0-2.67-3L30.89 11l.22-2 5.44.6a5 5 0 0 1 4.45 5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M35 15h2v7h-2z"
})));

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.7d1048c6.svg";
export { ForwardRef as ReactComponent };